import { createSelector } from '@ngrx/store';
import { IProductionToolingState, IRemoteXPACPortalState } from '../../utils/interfaces/store.interfaces';

export const selectProduction = (state: IRemoteXPACPortalState) => state.productionTooling;

export const selectProductionToolingPermissions = createSelector(
  selectProduction,
  (state: IProductionToolingState) => state.permission
);

export const selectDevices = createSelector(
  selectProduction,
  (state: IProductionToolingState) => state.devices
);

export const selectFirmware = createSelector(
  selectProduction,
  (state: IProductionToolingState) => state.firmware
);

export const selectDeviceProfiles = createSelector(
  selectProduction,
  (state: IProductionToolingState) => state.deviceProfiles
);

export const selectMacRanges = createSelector(
  selectProduction,
  (state) => state.macRanges,
)